import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { Download, Printer, Filter, Calendar } from 'lucide-react';
const categoryData = [{
  name: 'Food',
  value: 45200,
  color: '#10B981'
}, {
  name: 'Liquor',
  value: 28500,
  color: '#6366F1'
}, {
  name: 'Beer & Wine',
  value: 12400,
  color: '#F59E0B'
}, {
  name: 'N/A Beverage',
  value: 4200,
  color: '#3B82F6'
}, {
  name: 'Paper & Plastic',
  value: 3800,
  color: '#94A3B8'
}];
const locationData = [{
  name: 'Walk In',
  value: 18500
}, {
  name: 'Liquor Room',
  value: 22400
}, {
  name: 'Freezer 1',
  value: 12800
}, {
  name: 'Main Bar',
  value: 8500
}, {
  name: 'Prep Station',
  value: 15200
}];
export function ValuationReport() {
  const totalValuation = categoryData.reduce((sum, item) => sum + item.value, 0);
  return <div className="space-y-6" data-id="element-1142">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1143">
        <div data-id="element-1144">
          <h3 className="text-xl font-black text-slate-900" data-id="element-1145">
            Inventory Valuation
          </h3>
          <p className="text-sm font-bold text-slate-500" data-id="element-1146">
            Current asset value across all categories and locations
          </p>
        </div>
        <div className="flex items-center gap-2" data-id="element-1147">
          <button className="p-2 bg-white border border-slate-200 rounded-xl text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-1148">
            <Calendar size={18} data-id="element-1149" />
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-1150">
            <Download size={16} data-id="element-1151" />
            Export PDF
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1152">
        <div className="lg:col-span-1 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm flex flex-col items-center justify-center" data-id="element-1153">
          <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-8" data-id="element-1154">
            Valuation by Category
          </h4>
          <div className="h-64 w-full" data-id="element-1155">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1156">
              <PieChart data-id="element-1157">
                <Pie data={categoryData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-1158">
                  {categoryData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1159" />)}
                </Pie>
                <Tooltip formatter={(value: number) => `$${value.toLocaleString()}`} contentStyle={{
                borderRadius: '12px',
                border: 'none',
                boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)'
              }} data-id="element-1160" />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="mt-4 space-y-2 w-full" data-id="element-1161">
            {categoryData.map(item => <div key={item.name} className="flex items-center justify-between" data-id="element-1162">
                <div className="flex items-center gap-2" data-id="element-1163">
                  <div className="w-2 h-2 rounded-full" style={{
                backgroundColor: item.color
              }} data-id="element-1164" />
                  <span className="text-xs font-bold text-slate-600" data-id="element-1165">
                    {item.name}
                  </span>
                </div>
                <span className="text-xs font-black text-slate-900" data-id="element-1166">
                  ${item.value.toLocaleString()}
                </span>
              </div>)}
            <div className="pt-4 border-t border-slate-50 flex items-center justify-between" data-id="element-1167">
              <span className="text-sm font-black text-slate-900 uppercase tracking-widest" data-id="element-1168">
                Total
              </span>
              <span className="text-lg font-black text-emerald-600" data-id="element-1169">
                ${totalValuation.toLocaleString()}
              </span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-2 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-1170">
          <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-8" data-id="element-1171">
            Valuation by Location
          </h4>
          <div className="h-80 w-full" data-id="element-1172">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1173">
              <BarChart data={locationData} layout="vertical" margin={{
              left: 40,
              right: 40
            }} data-id="element-1174">
                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#F1F5F9" data-id="element-1175" />
                <XAxis type="number" hide data-id="element-1176" />
                <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
                fontSize: 10,
                fontWeight: 700,
                fill: '#94A3B8'
              }} data-id="element-1177" />
                <Tooltip formatter={(value: number) => `$${value.toLocaleString()}`} contentStyle={{
                borderRadius: '12px',
                border: 'none',
                boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)'
              }} data-id="element-1178" />
                <Bar dataKey="value" fill="#10B981" radius={[0, 4, 4, 0]} barSize={24} data-id="element-1179" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}